<script setup lang="ts">
withDefaults(defineProps<{
    text: string;
    tag?: string;
}>(), {
    tag: 'span',
});
</script>

<template>
    <Popover
        :tag="tag"
        :title="text"
        :aria-label="text"
        placement="top"
    >
        <slot></slot>
        <template #content>
            <slot name="tooltip">
                {{ text }}
            </slot>
        </template>
    </Popover>
</template>
